import React from "react";
import { useNavigate } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
// layouts
// import Layout from "./Layout/LayoutOld";
import Layout from "./Layout/Layout";
//Page
import Unit from "./Pages/Unit";
import Size from "./Pages/Size";
import Book from "./Pages/Book";
import Uniform from "./Pages/Uniform";
import MaterialUsing from "./Pages/MaterialUsing";
import Login from "./Pages/Login";
import Users from "./Pages/Users";
import Group from "./Pages/Group";
import Section from "./Pages/Section";
import LevelSection from "./Pages/LevelSection";
import Office from "./Pages/Office";
import Page404 from "./Pages/Page404";
import Setting from "./Pages/Setting";
import Category from "./Pages/Category";
import Supplier from "./Pages/Supplier";
import InventoryPlan from "./Pages/InventoryPlan"
import Report from "./Pages/Report";
import TakeOut from "./Pages/TakeOut";
// import Programme from "./Pages/Programme";
import Dashboard from "./Pages/Dashboard";
import Warehouse from "./Pages/Warehouse";
import ReqPurchase from "./Pages/ReqPurchase";
import Ajustment from "./Pages/Ajustment";
import MaterialName from "./Pages/MaterialName";
import MaterialNew from "./Pages/MaterialNew";
import ForgotPassword from "./Pages/ForgotPassword";
import StudentBook from "./Pages/StudentBook";
import ClassroomNeededItem from "./Pages/ClassroomNeededItem";
import OfficeInventory from "./Pages/OfficeInventory";
import Student from "./Pages/Student";

//Query
import { VERIFY_LOGIN } from "./Schema/User";
import StudentRentBook from "./Pages/StudentRentBook";

export default function Router({ prefersDarkMode, setPrefersDarkMode }) {
  const navigate = useNavigate();
  // =================== get user login ==================
  useQuery(VERIFY_LOGIN, {
    onCompleted: ({ verifyLogin }) => {
      localStorage.setItem("userLogin", JSON.stringify(verifyLogin));
    },
    onError: (error) => {
      localStorage.clear();
      navigate("/");
    },
    fetchPolicy: "network-only",
  });
  const userLogin = JSON.parse(localStorage.getItem("userLogin"));
  const token = localStorage.getItem("token");

  //  ======================================= check Route ===================================
  const LoginPage = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/login", element: <Login /> },
    { path: "forgot-password", element: <ForgotPassword /> },
    { path: "*", element: <Login /> },
  ]);

  const Content = useRoutes([
    {
      path: "/",
      element: (
        <Layout
          to="/dashboard"
          prefersDarkMode={prefersDarkMode}
          setPrefersDarkMode={setPrefersDarkMode}
        />
      ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "setting", element: <Setting /> },
        { path: "setting/unit", element: <Unit /> },
        { path: "setting/size", element: <Size /> },
        { path: "setting/user", element: <Users /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "setting/group", element: <Group /> },
        { path: "setting/section", element: <Section /> },
        { path: "setting/levelsection", element: <LevelSection /> },
        { path: "setting/office", element: <Office /> },
        { path: "reqpurchase", element: <ReqPurchase /> },
        { path: "setting/category", element: <Category /> },
        { path: "setting/supplier", element: <Supplier /> },
        { path: "setting/material", element: <MaterialNew /> },
        { path: "setting/warehouse", element: <Warehouse /> },
        { path: "setting/materialname", element: <MaterialName /> },
        {
          path: "setting/class-needed-items",
          element: <ClassroomNeededItem />,
        },
        { path: "ajustment", element: <Ajustment /> },
        { path: "plan", element: <InventoryPlan /> },
        { path: "report", element: <Report /> },
        { path: "studentbook", element: <StudentBook /> },
        { path: "studentrentbook", element: <StudentRentBook /> },
        { path: "student", element: <Student /> },
        { path: "book", element: <Book /> },
        { path: "uniform", element: <Uniform /> },
        { path: "materialusing", element: <MaterialUsing /> },
        { path: "takeout", element: <TakeOut /> },
        { path: "office-inventory", element: <OfficeInventory /> },
        { path: "*", element: <Page404 /> },
      ],
    },
  ]);

  if (!token || !userLogin) return LoginPage;
  return Content;
}
